export class ListInventorySnapshotsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "SnapshotFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortSnapshotsBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventorySnapshotsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
